import type { ReactNode } from "react";
import { useId } from "react";
import { useT } from "@transifex/react";
import useBreakpoints, { Breakpoint } from "../../hooks/useBreakpoints";

interface FilterBarLayoutProps {
    filterContent: (filterLabelId: string) => ReactNode;
    sortContent: (sortLabelId: string) => ReactNode;
}

const FilterBarLayout = (props: FilterBarLayoutProps) => {
    const t = useT();
    const { getStyleBasedOnBreakpoint } = useBreakpoints();
    const id = useId();
    const filterLabelId = `${id}-filter-by`;
    const sortLabelId = `${id}-sort-by`;

    const t_filterBy = t("Filter by:", { _tags: "FilterBar" });
    const t_sortBy = t("Sort by:", { _tags: "FilterBar" });

    return (
        <div
            className={`flex w-full items-start gap-s ${getStyleBasedOnBreakpoint(
                Breakpoint.MD,
                "flex-row flex-wrap justify-between",
                "flex-col"
            )}`}
        >
            <div
                className={`flex items-center ${getStyleBasedOnBreakpoint(
                    Breakpoint.MD,
                    "flex-row gap-s",
                    "flex-col items-start w-full gap-xs"
                )}`}
            >
                <span
                    id={filterLabelId}
                    className="text-l text-p6-grey-dark whitespace-nowrap"
                >
                    {t_filterBy}
                </span>
                <div
                    className={`flex items-center gap-xs ${getStyleBasedOnBreakpoint(
                        Breakpoint.MD,
                        "flex-row",
                        "flex-col w-full"
                    )}`}
                >
                    {props.filterContent(filterLabelId)}
                </div>
            </div>

            <div
                className={`flex items-center ${getStyleBasedOnBreakpoint(
                    Breakpoint.MD,
                    "flex-row gap-s",
                    "flex-col items-start w-full gap-xs"
                )}`}
            >
                <span
                    id={sortLabelId}
                    className="text-l text-p6-grey-dark whitespace-nowrap"
                >
                    {t_sortBy}
                </span>
                <div className={getStyleBasedOnBreakpoint(Breakpoint.MD, "w-fit", "w-full")}>
                    {props.sortContent(sortLabelId)}
                </div>
            </div>
        </div>
    );
};

export default FilterBarLayout;
